"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseButton = void 0;
var core_1 = require("@material-ui/core");
var styled_components_1 = __importDefault(require("styled-components"));
exports.BaseButton = styled_components_1.default(core_1.Button).withConfig({ displayName: "BaseButton", componentId: "sc-mpwp8m" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["width:", ";min-width:4rem;box-sizing:border-box;font-size:", ";font-weight:500;padding:", ";border-radius:", ";line-height:", ";text-transform:none;&,&:hover{background-color:", ";border:1px solid ", ";color:", ";}@media (hover: hover){&:hover{background-color:", ";border-color:", ";color:", ";}}&:active{background-color:", ";border-color:", ";color:", ";}&:disabled,&.MuiButton-root.Mui-disabled{background-color:", ";border-color:", ";color:", ";}"], ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""])), function (_a) {
    var $fullWidth = _a.$fullWidth;
    return ($fullWidth ? '100%' : 'auto');
}, function (_a) {
    var theme = _a.theme, $size = _a.$size;
    return theme.vui.component.button.size[$size].fontSize;
}, function (_a) {
    var theme = _a.theme, $size = _a.$size;
    return theme.vui.component.button.size[$size].padding;
}, function (_a) {
    var theme = _a.theme, $size = _a.$size;
    return theme.vui.component.button.size[$size].borderRadius;
}, function (_a) {
    var theme = _a.theme, $size = _a.$size;
    return theme.vui.component.button.size[$size].lineHeight;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].default.background;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].default.border;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].default.font;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].hover.background;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].hover.border;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].hover.font;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].pressed.background;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].pressed.border;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].pressed.font;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].disabled.background;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].disabled.border;
}, function (_a) {
    var theme = _a.theme, $variant = _a.$variant;
    return theme.vui.component.button.variant[$variant].disabled.font;
});
var templateObject_1;
